export default __webpack_public_path__ + "static/media/fmbmi-grey.84fc7022.png";